export const info = [
  {
    name: 'Nových záznamů',
    count: 14,
    agendaId: '',
    viewId: '',
  },
  {
    name: 'Nových záznamů',
    count: 4,
    agendaId: '',
    viewId: '',
  },
  {
    name: 'Nových záznamů',
    count: 8,
    agendaId: '',
    viewId: '',
  },
  {
    name: 'Nových záznamů',
    count: 8,
    agendaId: '',
    viewId: '',
  },
];

export const modules = [
  {
    title: '...',
    moduleId: '1',
    items: [
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
    ],
  },
  {
    title: '...',
    moduleId: '2',
    items: [
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
    ],
  },
  {
    title: '...',
    moduleId: '3',
    items: [
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
    ],
  },
  {
    title: '...',
    moduleId: '4',
    items: [
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
      {
        title: '...',
        agendaId: '',
        sourceType: 'core',
      },
    ],
  },
];
